import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Identifiants incorrects');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center th-bg px-4 transition-colors duration-300">
      <div className="w-full max-w-sm animate-fadeInUp">
        <div className="text-center mb-8">
          <Link to="/" className="font-mono font-bold text-2xl text-accent tracking-[0.15em]">STRIDERR</Link>
          <p className="mt-2 text-sm th-text-secondary">Connecte-toi à ton compte</p>
        </div>

        <form onSubmit={handleSubmit} className="border th-border p-6 space-y-6 th-bg-surface transition-colors duration-300">
          {error && (
            <div className="border border-status-rejected/30 text-status-rejected px-3 py-2 text-sm font-mono">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="email" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="th-input"
              placeholder="ton@email.com"
            />
          </div>

          <div>
            <div className="flex items-center justify-between mb-2">
              <label htmlFor="password" className="block text-xs font-mono th-text-secondary uppercase tracking-widest">
                Mot de passe
              </label>
              <Link to="/forgot-password" className="text-xs th-text-muted hover:text-accent transition-colors duration-150 font-mono">
                Mot de passe oublié ?
              </Link>
            </div>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="th-input"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full th-btn-accent"
          >
            {submitting ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <p className="text-center mt-6 text-sm th-text-muted">
          Pas encore de compte ?{' '}
          <Link to="/register" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono">
            Créer un compte
          </Link>
        </p>
      </div>
    </div>
  );
}
